// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

export interface BackfillError {
  brokerageId: string;
  message: string;
}

export interface BrokerageBackfillReport {
  dryRun: boolean;
  totalScanned: number;
  eventsEmitted: number;
  skipped: number;
  errors: BackfillError[];
  startedAt: string;
  completedAt: string;
}

export interface BackfillOptions {
  dryRun: boolean;
  brokerageIds?: string[];
  batchSize?: number;
}

const API_BASE = '/api/admin/brokerage-events';

export const brokerageEventsApi = {
  async runBackfill(options: BackfillOptions): Promise<BrokerageBackfillReport> {
    const params = new URLSearchParams({ dryRun: String(options.dryRun) });
    if (options.batchSize !== undefined) {
      params.append('batchSize', String(options.batchSize));
    }
    (options.brokerageIds ?? []).forEach(id => params.append('brokerageIds', id));

    const response = await fetch(`${API_BASE}/backfill?${params}`, {
      method: 'POST',
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(text || `Backfill failed (${response.status})`);
    }
    return response.json();
  },
};
